import { P2GBox, P2GContainer, P2GGrid, P2GText, useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { FC, ReactNode, Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
import Loading from '~/components/core/progress/loading';
import useBasket from '~/hooks/use-basket';
import Stepper from '~/components/core/stepper/stepper';
import Sidebar from '~/components/core/sidebar/checkout-sidebar';
import { Workflow } from '~/lib/types/workflow-types';
import SupportingLabel from '~/components/supporting-label/supporting-label';
import { ToStepperTitle } from '~/components/core/stepper/to-stepper-title';
import { Form, TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import { useOrderContent } from '~/hooks/use-order-content';

const CmsContent = lazy(() => import('~/components/core/content/cms-content'));

const Component: FC<{ children: ReactNode; workflow: Workflow; path: string }> = (props) => {
  useOrderContent();
  const { initialised } = useBasket();
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);
  const isXs = useP2GMediaQueryOnly('xs');

  return (
    <P2GContainer maxWidth="lg">
      <P2GBox pb={4}>
        <Suspense>
          <CmsContent contentKey="main-banner" wrapper={(x) => <P2GBox mb={2}>{x}</P2GBox>} />
        </Suspense>
        <Stepper workflow={props.workflow} path={props.path} formId={Form.CHECKOUTID} />
        <P2GGrid container spacing={2}>
          <P2GGrid item xs={12}>
            {isXs && (
              <P2GText variant="h2">
                {t(`STEPPER_STEP_${props.path.toUpperCase()}`, { defaultValue: ToStepperTitle(props.path) })}
              </P2GText>
            )}
            <SupportingLabel
              text={t(`REQUIRED_FIELDS_MESSAGE`, { defaultValue: 'Fields marked with * are required.' })}
            />
          </P2GGrid>
          <P2GGrid item xs={12} sm={8} lg={9}>
            {initialised && (
              <section>
                <Outlet />
                {props.children}
              </section>
            )}
          </P2GGrid>
          {!isXs && (
            <P2GGrid item xs={12} sm={4} lg={3} alignSelf={'flex-start'} position={'sticky'} top={60}>
              <aside>
                <Suspense fallback={<Loading />}>
                  <Sidebar />
                </Suspense>
              </aside>
            </P2GGrid>
          )}
        </P2GGrid>
      </P2GBox>
    </P2GContainer>
  );
};
export default Component;
